import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t", "\n\t"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t", "\n\t"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding: 3px 0;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-right: -4px;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-radius: ", ";\n\tbox-shadow: 0 0 0 1px ", " inset;\n\tcursor: default;\n\tdisplay: flex;\n\theight: 20px;\n\tline-height: 1;\n\tmax-width: 120px;\n\tpadding: 0 4px;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, getBackgroundColor, getBackgroundColorText, styled, ui } from '@wp-g2/styles';
export var TagView = styled.div(_templateObject(), ui.get('controlBorderRadius'), ui.get('surfaceBorderColor'));
export var RemoveButtonView = styled.div(_templateObject2());
export var text = css(_templateObject3());
export function getBackground(_ref) {
  var color = _ref.color;
  return css(_templateObject4(), getBackgroundColor(color));
}
export function getBackgroundText(_ref2) {
  var color = _ref2.color;
  return css(_templateObject5(), getBackgroundColorText(color));
}